import React, { useState } from 'react';
import { RuleList } from './RuleList';
import { RuleForm } from './RuleForm';
import { TestModal } from './TestModal';
import { AccountMatchingRule } from '../../types/api';

export const AccountMatching: React.FC = () => {
  const [showRuleForm, setShowRuleForm] = useState(false);
  const [showTestModal, setShowTestModal] = useState(false);
  const [editingRule, setEditingRule] = useState<AccountMatchingRule | null>(null);
  const [testingRule, setTestingRule] = useState<AccountMatchingRule | null>(null);

  const handleCreateRule = () => {
    setEditingRule(null);
    setShowRuleForm(true);
  };

  const handleEditRule = (rule: AccountMatchingRule) => {
    setEditingRule(rule);
    setShowRuleForm(true);
  };

  const handleTestRule = (rule: AccountMatchingRule) => {
    setTestingRule(rule);
    setShowTestModal(true);
  };

  const handleCloseRuleForm = () => {
    setShowRuleForm(false);
    setEditingRule(null);
  };

  const handleCloseTestModal = () => {
    setShowTestModal(false);
    setTestingRule(null);
  };

  const handleSaveRule = () => {
    setShowRuleForm(false);
    setEditingRule(null);
    // The RuleList component will refresh automatically
  };

  return (
    <>
      <RuleList
        onCreateRule={handleCreateRule}
        onEditRule={handleEditRule}
        onTestRule={handleTestRule}
      />

      <RuleForm
        rule={editingRule || undefined}
        isOpen={showRuleForm}
        onClose={handleCloseRuleForm}
        onSave={handleSaveRule}
      />

      <TestModal
        rule={testingRule}
        isOpen={showTestModal}
        onClose={handleCloseTestModal}
      />
    </>
  );
};